import { useQuery } from "@tanstack/react-query";
import { getOrganization, OrganizationType } from "@/api/organization";

export const useOrganization = (unitName: string, language: number = 0) => {
  return useQuery<OrganizationType, Error>({
    queryKey: ["organization", unitName, language],
    queryFn: () => getOrganization(unitName, language),
    enabled: !!unitName, // Only run query if unitName is provided
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};